export default {
  allIdentifiedProblems: [],
  identifiedProblem: {},
}
